export default "__VITE_ASSET__Di9imt4w__"